import type { CategoryFacet } from './CategoryFacet'
import type { CustomFacet } from './CustomFacet'
import type { ManufacturerFacet } from './ManufacturerFacet'
import type { Product } from './Product'
import type { LanguageId, ValueOf } from '@model/locales'
import type { Facet } from '@model/category/Facet'
import { Catalog } from '@model/pricelist/Catalog'

export interface ProductSearchResult {
  maxPrice: number
  minPrice: number
  taxMultiplier: number
  totalNumProducts: number
  productArray: Product[]
  manufacturerFacets: ManufacturerFacet[]
  categoryFacets: CategoryFacet[]
  customFacets: CustomFacet[]
}

export interface RecommendationsResult {
  productArray: Product[]
}

export const KK_ORDER_BY_VALUES = {
  none: null,
  priceAscending: 'ORDER_BY_PRICE_ASCENDING',
  priceDescending: 'ORDER_BY_PRICE_DESCENDING',
  nameToZ: 'ORDER_BY_NAME_ASCENDING',
  nameToA: 'ORDER_BY_NAME_DESCENDING',
  byBestSellers: 'ORDER_BY_TIMES_ORDERED_DESCENDING',
  recommended: 'ORDER_BY_RECOMMENDATION',
  addedDescending: 'ORDER_BY_DATE_ADDED_DESCENDING',
} as const

export type OrderKey = keyof typeof KK_ORDER_BY_VALUES
export type SortOrder = ValueOf<typeof KK_ORDER_BY_VALUES>

export type TagGroup = {
  facetNumber: number
  facetConstraints: string[]
}

export interface ProductSearchFilter {
  languageId: LanguageId
  catalogId: Catalog
  limit?: number
  offset?: number
  manufacturerIds?: number[]
  categoryIds?: number[]
  categoryId?: number
  priceTo?: number
  priceFrom?: number
  facets?: Facet[]
  tagGroups?: TagGroup[]
  searchText?: string
  searchTextRule?: number
  orderBy?: SortOrder
  manufacturerId?: number
  returnManufacturerFacets?: boolean
}
